module.exports = __webpack_public_path__ + "media/images/press_kit/shoretime_dark/main-e60945d901c9c8a82faac89a76bdf9fc.png";